export default __webpack_public_path__ + "static/media/bg15.ba5b7a48.jpg";